import type {ActionTree, GetterTree} from 'vuex';
import axios from 'axios';
import * as types from '@/store/mutation-types';

export interface SquareState {
    loading: Record<string, boolean>;
    currentWorkingInvoice: any;
}

export interface SquareActions {
    getSquareOauthUrl(context: any): Promise<{ url?: string } | undefined>;

    saveSquareCode(context: any, data: { code: string; state: string }): Promise<unknown>;

    getSquareProvider(context: any): Promise<{ square?: unknown } | undefined>;

    testPayment(context: any, squareId: string): Promise<unknown>;
}

// state
const state: SquareState = {
    loading: {
        square_oauth: false,
        fetchCart: false,
    },
    currentWorkingInvoice: '',
};

const getters: GetterTree<SquareState, any> = {
    loading: (state) => state.loading,
};

const mutations = {
    [types.SET_SQUARE_LOADING](state: SquareState, loading: { subject: string, loading: boolean }) {
        state.loading[loading.subject] = loading.loading;
    },
};

const actions: ActionTree<SquareState, any> & SquareActions = {

    async getSquareOauthUrl({commit}) {
        commit(types.SET_SQUARE_LOADING, {subject: 'square_oauth', loading: true});

        try {
            const response = await axios.get('/v1/square/url');

            return response.data;
        } catch (error) {
            console.error('Error fetching Square OAuth URL:', error);
        } finally {
            commit(types.SET_SQUARE_LOADING, {subject: 'square_oauth', loading: false});
        }
    },

    async saveSquareCode({commit}, data: { code: string; state: string }) {
        commit(types.SET_SQUARE_LOADING, {subject: 'square_oauth', loading: true});

        try {
            const response = await axios.post('/v1/square/redirect', data);
            return response.data;
        } catch (error) {
            console.error('Error saving Square OAuth code:', error);
        } finally {
            commit(types.SET_SQUARE_LOADING, {subject: 'square_oauth', loading: false});
        }
    },

    async getSquareProvider() {
        try {
            const response = await axios.get('/v1/square/');
            return response.data;
        } catch (error) {
            console.error('Error fetching Square provider:', error);
        }
    },

    async testPayment(_, squareId: string) {
        try {
            const response = await axios.post(`/v1/square/testPayment?squareId=${squareId}`);

            return response.data;
        } catch (error) {
            console.error('Error testing Square payment:', error);
        }
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
};
